import { useState, useEffect } from "react";
import InfoButton from "../InfoButton";
import InformationPopup from "../../Popups/InformationPopup";

export default function Sterile(props) {
    const [selected, setSelected] = useState(null);
    const [buttons, setButtons] = useState([]);
    const [clicked, setClicked] = useState(false);
    const [popupButtonHtml, setPopupButtonHtml] = useState(null);
    const [popupHtml, setPopupHtml] = useState(null);

    useEffect(() => {
        renderButtons();
    }, [props.sterileOptions]);

    useEffect(() => {
        if (clicked === true) {
            setTimeout(() => {
                // Submit the form
                submit();
            }, 100);
        }
    }, [selected]);

    function clickYes() {
        // Check props.productSettingsExclusions
        let result = true;
        if (props.productSettingsExclusions) {
            // Check if sterile is excluded
            props.productSettingsExclusions.forEach((exclusion) => {
                if (
                    exclusion.isAllowed === false &&
                    exclusion.sterile === true &&
                    exclusion.application === "Medical"
                ) {
                    result = false;
                }
            });
        }

        // Check if there is an exclusion which allows sterile
        if (props.productSettingsExclusions) {
            // Check if sterile is excluded
            props.productSettingsExclusions.forEach((exclusion) => {
                if (exclusion.isAllowed === true && exclusion.sterile === true && exclusion.application === "Medical") {
                    result = true;
                }
            });
        }

        return result;
    }

    function clickSelect(e, i) {
        let included = false;
        props.sterileOptions.forEach((option) => {
            if (option === true) {
                included = true;
            }
        });

        const showPopup = clickYes();

        if (i === 1) {
            if (showPopup === false) {
                setClicked(true);
                openPopup(e);
                return;
            }
        }

        // bugfix for when the user clicks on the same button after popup
        if (!included && typeof (selected === "undefined" || selected === null)) {
            props.updateSetting("sterile", false);
            props.goNext("overview");
            props.clearSettingsThatAreNotAllowed(false, "sterile");
        }

        select(e, i);
        setClicked(true);
    }

    function closeInfoPopup() {
        setPopupHtml(null);
        let modals = document.getElementsByClassName("modal-background");
        if (typeof modals !== "undefined" && modals.length > 0) {
            modals[0].remove();
        }
        console.log("closeInfoPopup called");
    }

    function openPopup(e) {
        const body = document.getElementsByTagName("body")[0];
        const modalBackground = document.createElement("div");
        modalBackground.classList.add("modal-background");
        modalBackground.addEventListener("click", closeInfoPopup);
        body.appendChild(modalBackground);

        setPopupHtml(
            <InformationPopup
                content={
                    <div className="sterile-popup">
                        <button className="close-popup" onClick={closeInfoPopup}>
                            <span className="ico --close"></span>
                        </button>
                        <div className="header-img-container --no-bg">
                            <img src="/3dmedical.png" alt="3d" className="logo" />
                            <h1>Information regarding 3D surgical medical devices</h1>
                            <h3>ISO-13485 certified platform for medical class IIa devices</h3>
                            <button
                                className="popup-header-button"
                                onClick={function () {
                                    window.open("https://oceanz.3d-customize.com/", "_blank");
                                }}
                            >
                                Go to oceanz.3d-customize.com
                            </button>
                        </div>
                        <div className="info-text">
                            <p>
                                To comply with all requirements and guidelines of the Medical Device Regulation (MDR),
                                custom-made 3D-printed medical devices for sterile use (Class IIa) must be ordered
                                through our certified communication platform. This platform ensures secure, patient-safe
                                data transfer and includes an end-user validation step.
                            </p>
                            <p>
                                You can create an account and place your order at:{" "}
                                <a href="https://oceanz.3d-customize.com/" target="_blank">
                                    oceanz.3d-customize.com
                                </a>
                            </p>
                            <p>
                                For non–custom-made 3D-printed medical devices for sterile use, please contact our team
                                using the contact details below. We would be happy to walk through the specific
                                requirements together to ensure the production process meets all applicable standards.
                                If you have any questions or would like additional information, feel free to get in
                                touch with us.
                            </p>
                        </div>
                        <div className="popup-footer">
                            <div className="images">
                                <img src="./photo2.jpg" alt="photo1" />
                                <img src="./photo1.jpg" alt="photo2" />
                            </div>
                            <div class="contact-info">
                                <p>
                                    <span class="ico --tel"></span> <span class="value">+31(0) 852 017 406</span>
                                </p>
                                <p>
                                    <span class="ico --mail"></span>{" "}
                                    <span class="value">
                                        <a href="mailto:info@3dmedicalmodels.nl">info@3dmedicalmodels.nl</a>
                                    </span>
                                </p>
                                <p>
                                    <span class="ico --web"></span>{" "}
                                    <span class="value">
                                        <a href="http://www.3dmedicalmodels.nl" target="_blank">
                                            www.3dmedicalmodels.nl
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                }
            />
        );
        setClicked(false);
    }

    function includePopupLinkIfNoYesButton() {
        // Check if the yes options is included in sterileOptions
        let included = false;
        props.sterileOptions.forEach((option) => {
            if (option === true) {
                included = true;
            }
        });

        if (!included) {
            return (
                <div className="material-container">
                    <button
                        className={`btn btn-option`}
                        value={"Yes"}
                        onClick={(e) => {
                            openPopup(e);
                        }}
                    >
                        {props.textData.yes_btn}
                    </button>
                </div>
            );
        }
    }

    function renderButtons() {
        const buttonsArray = Object.entries(props.sterileOptions).map(([key, value], i) => (
            <div className="material-container" key={i}>
                <button
                    className={`btn btn-option 
                    ${props.config.sterile === null && i === 0 ? "selected" : ""}
                    ${JSON.parse(props.config.sterile) === value ? "selected" : ""}`}
                    value={value}
                    onClick={(e) => clickSelect(e, i)}
                >
                    {value ? props.textData.yes_btn : props.textData.no_btn}
                </button>
            </div>
        ));
        setPopupButtonHtml(includePopupLinkIfNoYesButton());
        setButtons(buttonsArray);
        // set selected to selected
        if (props.config.sterile !== null) {
            setSelected(document.getElementsByClassName("btn-option selected")[0]);
        }
    }

    function select(e, i) {
        // if already selected, return to overview
        if (e.target.classList.contains("selected")) {
            props.goNext("overview");
        }

        // Remove selected class from all buttons
        const container = document.getElementsByClassName("materials-settings-details");
        const buttons = container[0].getElementsByClassName("btn-option");
        for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove("selected");
        // Add selected class to clicked button
        setSelected(e.target);
        e.target.classList.add("selected");
    }

    function submit() {
        if (selected !== null) {
            props.updateSetting("sterile", selected.value);
            if (selected.value === true || selected.value === "true") {
                props.updateSetting("intendedUse", "Max 24h surgically invasive use");
            }
        } else {
            // Check if there is a button with state selected
            let btn = document.getElementsByClassName("btn-option selected")[0];
            if (btn !== null && typeof btn !== "undefined") {
                props.updateSetting("sterile", btn.value);
            }
        }
        props.goNext("overview");
        props.clearSettingsThatAreNotAllowed(false, "sterile");
    }

    function goBack() {
        props.goNext("application");
    }

    return (
        <div className="materials-settings-details">
            {popupHtml}
            <h1>{props.textData.title}</h1>
            <br />
            <p className="subtitle">{props.textData.subtitle}</p>
            <br />
            <h2 className="h2-info-parent">{props.textData.header}</h2>
            <InfoButton
                info={props.productSettingExplanations.filter((info) => {
                    return info.type === "sterile";
                })}
                textData={props.infoTextData}
            />
            <div className="material-btns">
                {buttons}
                {popupButtonHtml}
            </div>
            {props.sterileOptions !== null && props.sterileOptions.length > 0 ? (
                ""
            ) : (
                <p>{props.textData.not_available}</p>
            )}
        </div>
    );
}
